var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0"},[_c('v-row',[_c('v-col',{staticClass:"mx-0 px-0 pt-0"},[_c('header-text-bg',{attrs:{"site":_vm.site,"text":_vm.site.menu_mission_suggest_text || 'recommendMission'}})],1)],1),_c('listMissionVertical',{attrs:{"site":_vm.site,"dataItems":_vm.dataMissionRecommended,"typeActivity":"active"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }